
const state = {
    tableHeight: 1 // 表格高度变化
};

const mutations = {
    setTableHeight(state, data) {
        state.tableHeight = data;
    },
};

const actions = {
    setTableHeight({commit, state}) {
        let data = state.tableHeight + 1
        commit("setTableHeight", data || []);
      },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
